import serviceNames from '~setup/AnalyticsService';
import { diContainer } from '~setup/diContainer';
import { AnalyticsDriver } from '../AnalyticsDriver';

export class AnalyticsLoadedUseCase {
    private analyticsDriver: AnalyticsDriver;

    constructor() {
        this.analyticsDriver = diContainer.get(serviceNames.analyticsDriver);
    }

    public execute = () => {
        if (!this.analyticsDriver.isLoaded) {
            // TODO: load user data into data layer
            // TODO: load cart data into data layer
            this.analyticsDriver.enable();
        }
    };
}
